import { addDays, addHours } from "date-fns/esm";

import { PeriodValue } from "ds/components/Datepicker/types";

export const DATE_RANGE_PERIODS = {
  last1Hour: {
    label: "Last 1 Hour",
    range: () => ({
      start: addHours(new Date(), -1),
      end: new Date(),
    }),
  },
  last4Hours: {
    label: "Last 4 Hours",
    range: () => ({
      start: addHours(new Date(), -4),
      end: new Date(),
    }),
  },
  last24Hours: {
    label: "Last 24 Hours",
    range: () => ({
      start: addDays(new Date(), -1),
      end: new Date(),
    }),
  },
  last7Days: {
    label: "Last 7 days",
    range: () => ({
      start: addDays(new Date(), -7),
      end: new Date(),
    }),
  },
} satisfies Record<string, PeriodValue>;

export type DateRangePeriod = keyof typeof DATE_RANGE_PERIODS;

export const isDateRangePeriod = (value: string): value is DateRangePeriod =>
  value in DATE_RANGE_PERIODS;
